import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import icons from "../../../../public/img/icons/icons.svg";
import style from "./style.module.scss";
export default function Icon(props) {
    let height = 16;
    let width = 16;
    // some icons need their sizes tweaked to match
    switch (props.name) {
        case "updown":
            height = 12;
            width = 12;
            break;
        case "compare":
            height = 11;
            width = 13;
            break;
        case "eye":
            height = 9;
            width = 13;
            break;
        case "rotate-arrows":
            height = 12;
            width = 12;
            break;
        case "plus":
            height = 13;
            width = 13;
            break;
        case "pencil":
            height = 12;
            width = 12;
            break;
        case "caret--thin--right":
            height = 12;
            width = 8;
            break;
        case "caret--thin--down":
            height = 8;
            width = 12;
            break;
        case "caret--down":
            height = 10;
            width = 15;
            break;
        case "xmark--thick":
            height = 13;
            width = 13;
            break;
        case "check--thick":
            height = 13;
            width = 16;
            break;
        case "dash":
            height = 4;
            width = 15;
            break;
        case "caret--right":
            height = 12;
            width = 8;
            break;
        case "code":
            height = 15;
            width = 18;
            break;
        case "lock":
            height = 16;
            width = 13;
            break;
        case "cup":
            height = 20;
            width = 20;
            break;
        case "dragdrop":
            height = 18;
            width = 8;
            break;
        case "rum":
            height = 16;
            width = 22;
            break;
        case "list":
            height = 10;
            width = 17;
            break;
        case "grid":
            height = 11;
            width = 17;
            break;
        case "syn":
            height = 16;
            width = 18;
            break;
        case "arrow--double":
            height = 22;
            width = 20;
            break;
        case "arrows--left-right":
            height = 11;
            width = 13;
            break;
        case "expand":
        case "contract":
            height = 13;
            width = 13;
            break;
        case "warning":
        case "info":
        case "error":
        case "success":
            height = 24;
            width = 24;
            break;
    }
    // override sizes if specified
    if (props.height) {
        height = props.height;
    }
    if (props.width) {
        width = props.width;
    }
    if (props.name === "github") {
        return (_jsx("svg", { height: height, width: width, viewBox: "0 0 16 16", version: "1.1", className: classNames(style["icon--github"], props.className), children: _jsx("path", { d: "M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z" }) }));
    }
    /**
     * When webpack generates the URL for `icons`, it includes the origin of the script that is
     * currently executing. Since our scripts are hosted on a separate domain, this causes the SVG
     * to be a cross-origin request. Unfortunately most browsers seem to apply the same-origin
     * policy to <use> elements and refuse to load a cross-origin URL in the `href` attribute.
     *
     * According to MDN, there is currently no way to set a cross-origin policy for <use> elements.
     *
     * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Element/use#usage_notes
     */
    const iconsUrl = (() => {
        try {
            return new URL(icons);
        }
        catch (_e) {
            // Fallback for environments where the icons import is not a fully qualified URL
            return { pathname: icons };
        }
    })();
    return (_jsx("svg", { width: width, height: height, className: classNames(props.className, {
            [style["icon--spin"]]: props.spin,
        }), children: _jsx("use", { href: `${iconsUrl.pathname}#${props.name}` }) }));
}
